import { useQuery } from '@tanstack/react-query';
import { Alert } from 'antd';
import { api } from './api';
import { t } from './i18n';

/** Flag quota balances at or below this as "low". */
const LOW_QUOTA = 3;

/**
 * Prominent quota warning for clients: red when exhausted (can't flash), amber
 * when running low. Renders nothing for admins or when the balance is healthy.
 */
export function QuotaBanner({ role, style }: { role: string; style?: React.CSSProperties }) {
  const quota = useQuery({
    queryKey: ['my-quota'],
    queryFn: () => api.myQuota(),
    enabled: role === 'client',
    refetchInterval: 10_000,
  });
  if (role !== 'client' || !quota.data) return null;
  const available = quota.data.available;
  if (available === 0) {
    return (
      <Alert
        style={style ?? { marginBottom: 16 }}
        type="error"
        showIcon
        message={t('quotaExhaustedTitle')}
        description={t('quotaExhaustedHint')}
      />
    );
  }
  if (available <= LOW_QUOTA) {
    return (
      <Alert
        style={style ?? { marginBottom: 16 }}
        type="warning"
        showIcon
        message={t('quotaLowTitle', { n: available })}
        description={t('quotaLowHint')}
      />
    );
  }
  return null;
}
